import React, {Component} from 'react';

import Wait from '@react/react-spectrum/Wait';
import AppErrorPage from '../../components/errors/AppErrorPage';
import {
    isUnprocessableEntityError,
    normalizeApiErrorMessages,
} from '../../components/errors';
import Education from '../content/Education';
import SubmittedInReview from '../content/Common/Error/SubmittedInReview';
import UnauthorizedError from '../content/Common/Error/UnauthorizedError';
import UnauthorizedPlatinum from '../content/Common/Error/UnauthorizedPlatinum';

class EducationPage extends Component{

    constructor(props)
    {
        super(props);
    }

    state = {
        isLoading : true    
    }

    refreshApp = () =>{
        this.setState({isLoading:true});
        this.props.connector.searchEmail(this.onSearchComplete, this.props.formName);
    }

    componentDidMount(){
        this.refreshApp();
    }

    onSearchComplete = (data) =>{
        this.setState({data:data, isLoading:false});
    }

    render(){
        return <div>
            {this.props.isSaving ? <div className="overlay">                             
                                    <Wait size="L" centered/>
                                    <span className="saving-Text">Saving</span>
                                    </div> : null }
                {
                    this.state.isLoading 
                    ? <Wait size="L" centered/> 
                    : this.state.data.isError 
                        ? (
                            isUnprocessableEntityError(this.state.data)
                              ? <AppErrorPage title="Unable to load this page" errorPayload={this.state.data} messages={normalizeApiErrorMessages(this.state.data)} />
                              : (this.state.data.errorCode === "41004" || this.state.data.errorCode === "40301" || this.state.data.message==="Unauthorized access")
                                  ? ((this.state.data.data && this.state.data.data.level === "Platinum Certified") ? <UnauthorizedPlatinum {...this.props}/> : <UnauthorizedError/>)
                                  : this.state.data.errorCode === "41008"
                                      ? <SubmittedInReview {...this.props}/>
                                      : <AppErrorPage title="Unable to load this page" errorPayload={this.state.data} messages={normalizeApiErrorMessages(this.state.data)} />
                          )
                        : (this.state.data.contactInfo.mainContactType === "Primary" && this.state.data.specializationInfo && this.state.data.specializationInfo.education)
                            ? <Education partnerData={this.state.data} connector={this.props.connector} {...this.props}/>
                            : <UnauthorizedError/>
                    
                }
            </div>

    }
}

export default EducationPage;
